import React from "react";
import { useNavigate } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import { useState } from "react";
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/themes/saga-blue/theme.css'; // You can choose a different theme
import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';
import {
    Therapist1Img,
    Therapist2Img,
    Therapist3Img,
    Therapist4Img,
    Therapist5Img,
    Therapist6Img,
    Therapist7Img,
    Search1Icon
} from "../../Constant/Index";


const Booking = () => {
    const AllSteps = ["Book Appointment", "Select Therapist", "Payment Details"];
    const [step, SetStep] = useState(0);
    const [date, setDate] = useState(null);
    const [doctor, SetDoctor] = useState(false);
    const [info, SetInfo] = useState(false);
    const Therapists = [
        {
            Name: "Peter Williams",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist1Img
        },
        {
            Name: "Emily Clark",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist2Img
        },
        {
            Name: "John Doe",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist3Img
        },
        {
            Name: "Alexander Volk",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist4Img
        },
        {
            Name: "Emily Clark",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist5Img
        },
        {
            Name: "John Doe",
            Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            Img: Therapist6Img
        }
    ]
    const ToggleDetails = () => {
        SetDoctor((prevDoctor) => !prevDoctor);
    }
    const ToggleInfo = () => {
        SetInfo((prevDoctor) => !prevDoctor);

    }
    const ChangeStep = () => {
        SetStep(step + 1);
    }
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/thankyou');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading={AllSteps[step]} />
            <section className="booking-section">
                <div className="container">
                    <div className="booking-start">
                        <div className="col-lg-6 mx-auto">
                            <ul className="top-area">
                                {
                                    AllSteps.map((theStep, index) => (
                                        <>
                                            <li className={(index <= step) ? 'active' : ''}>
                                                <span className={`line`}></span>
                                                <span className="text">{(index <= step) ? theStep : ''}</span>
                                            </li>
                                        </>
                                    ))
                                }
                            </ul>
                        </div>
                        <form onSubmit={handleSubmit} className="form-area">
                            {step == 0 &&
                                <>
                                    <div className={`single-step ${step}`}>
                                        <div className="col-lg-10 col-md-12 mx-auto">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="clendar-here">
                                                        <label htmlFor="" className="main-label">Select from available date</label>
                                                        <Calendar value={date} onChange={(e) => setDate(e.value)} inline />
                                                    </div>
                                                </div>
                                                <div className="col-md-7 mt-5 mt-md-0 ps-lg-5">
                                                    <div className="time-info ps-xl-5">
                                                        <div className="select-time">
                                                            <label className="main-label">Select from the Available Time</label>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="single-time">
                                                                        <label className="time">
                                                                            <input type="radio" name="Time" id="Time1" value="9:30-10:30 AM" hidden />
                                                                            <label for="Time1">9:30-10:30 AM</label>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="single-time">
                                                                        <label className="time">
                                                                            <input type="radio" name="Time" id="Time2" value="10:30-11:30 AM" hidden />
                                                                            <label for="Time2">10:30-11:30 AM</label>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="single-time">
                                                                        <label className="time">
                                                                            <input type="radio" name="Time" id="Time3" value="10:30-11:30 AM" hidden />
                                                                            <label for="Time3">10:30-11:30 AM</label>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="single-time">
                                                                        <label className="time">
                                                                            <input type="radio" name="Time" id="Time4" value="11:30-12:30 PM" hidden />
                                                                            <label for="Time4">11:30-12:30 PM</label>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="personal-info mt-4 pt-1">
                                                            <label className="main-label">Personal Info</label>
                                                            <div className="row">
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="form-group">
                                                                        <input type="text" name="" id="" className="form-control" placeholder="First Name" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="form-group">
                                                                        <input type="text" name="" id="" className="form-control" placeholder="Last Name" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="form-group">
                                                                        <input type="text" name="" id="" className="form-control" placeholder="Enter Email" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="form-group">
                                                                        <input type="text" name="" id="" className="form-control" placeholder="Phone Number" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 mb-3">
                                                                    <div className="form-group">
                                                                        <textarea name="" id="" rows="4" className="form-control" placeholder="Reason for booking the service" ></textarea>
                                                                        {/* <input type="text" name="" id="" /> */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 mb-3">
                                                                    <button type="button" onClick={ChangeStep} className="btn px-5">Proceed to Next Step</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                step == 1 &&
                                <div className={`single-step ${step}`}>
                                    {!doctor &&
                                        <div className="col-xl-6 col-lg-8 col-md-10 mx-auto">
                                            <div className="select-therapist">
                                                <label className="main-label text-center">Select from Available Therapist</label>
                                                <div className="filter form-group password">
                                                    <input type="text" name="" id="" className="form-control" placeholder="Search" />
                                                    <button className="show-password " type="button"><img src={Search1Icon} alt="" /></button>
                                                </div>
                                                <div className="therapist-list">
                                                    {
                                                        Therapists.map((therapist, index) => (
                                                            <div className="single-therapist" key={index}>
                                                                <div className="therapist-data">
                                                                    <figure className="therapist-img">
                                                                        <img src={therapist.Img} alt={therapist.Name} className="img-here" />
                                                                    </figure>
                                                                    <div className="about-therapist">
                                                                        <h6 className="xs-heading small">{therapist.Name}</h6>
                                                                        <p className="text mb-0">{therapist.Details}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="view-details">
                                                                    <button className="link-here" onClick={ToggleDetails} type="button">View Profile</button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        doctor &&
                                        <div className="col-md-6 mx-auto">
                                            <div className="therapist-details">
                                                <label className="main-label text-center pb-5">Therapist Details</label>
                                                <div className="doctor with-bg">
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <figure className="therapist-lg-imge">
                                                                <img src={Therapist7Img} className="img-here img-fluid w-100" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <div className="some-details pt-3">
                                                                <div className="top-details">
                                                                    <h6 className="xs-heading mb-0">Peter Williams</h6>
                                                                    <p className="text secondary-text-therapist">Psychotherapist</p>
                                                                </div>
                                                                <div className="bio-info">
                                                                    <div className="bio">
                                                                        <span className="text">Bio :</span>
                                                                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                                                                        {info &&
                                                                            <div className="personal-info pb-2">
                                                                                <span className="text">Personal Info :</span>
                                                                                <div className="row mx-0">
                                                                                    <div className="col-4 px-0">
                                                                                        <span className="text single-info">First Name</span>
                                                                                    </div>
                                                                                    <div className="col-8 px-0">
                                                                                        <span className="text single-info">Peter</span>
                                                                                    </div>
                                                                                    <div className="col-4 px-0">
                                                                                        <span className="text single-info">Last Name</span>
                                                                                    </div>
                                                                                    <div className="col-8 px-0">
                                                                                        <span className="text single-info">Williams</span>
                                                                                    </div>
                                                                                    <div className="col-4 px-0">
                                                                                        <span className="text single-info">Date of Birth</span>
                                                                                    </div>
                                                                                    <div className="col-8 px-0">
                                                                                        <span className="text single-info">22-Dec-2023</span>
                                                                                    </div>
                                                                                    <div className="col-4 px-0">
                                                                                        <span className="text single-info">Gender</span>
                                                                                    </div>
                                                                                    <div className="col-8 px-0">
                                                                                        <span className="text single-info">Female</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        <button className="btn secondary-btn mt-2" onClick={ToggleInfo} type="button">{(info) ? 'Hide ' : 'Show'} Personal Info</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="more-options d-flex flex-column flex-sm-row gap-3 justify-content-center mt-5 pt-lg-4 col-xl-10 ps-xl-3 mx-auto">
                                                    <button type="button" onClick={ToggleDetails} className="btn  w-100 px-1 transparent-btn w-xl-50">View Other Therapist</button>
                                                    <button type="button" className="btn w-100 px-1 w-xl-50" onClick={ChangeStep}>Book Therapist</button>
                                                </div>

                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                step == 2 &&
                                <div className={`single-step ${step}`}>
                                    <div className="col-md-6 col-xl-5 mx-auto">
                                        <div className="payment-step">
                                            <label htmlFor="" className="main-label text-center">Payment Details</label>
                                            <div className="form-group payment mb-3">
                                                <input type="text" name="" id="" className="form-control number" placeholder="xxxx xxxx xxxx xxxx" />
                                                <input type="text" name="" className="form-control mm" id="" placeholder="MM/YY" />
                                                <input type="text" name="" className="form-control cvv" id="" placeholder="CVC" />
                                            </div>
                                            <button type="submit" className="btn w-100 d-block">Pay Now</button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </form>
                    </div>
                </div>
            </section>
            <Newsletter />
            <Footer />
        </>
    )
}
export default Booking;